import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
// import { NavLink } from 'react-router-dom';
import fonts from 'src/constants/fonts';
import stylesheet, { mainColor, secondaryColor } from 'src/constants/stylesheet';
// import { Language } from 'src/utils/Languages';
import scrollToId from 'src/utils/scrollToId';
// import useRouter from 'use-react-router';

const useStyles = makeStyles(() =>
  createStyles({
    navItem: {
      ...fonts.NeueHaasGroteskBold,
      color: secondaryColor,
      '&:hover': {
        color: mainColor
      },
      '[data-type="Exhibitions"] &': {
        ...stylesheet.SubTitle,
      }
    },
    navItemActive: {
      color: mainColor,
      cursor: 'pointer'
    },
    ul: {
      '&:first-child': {
        marginBottom: 20
      }
    }
  }));
export type SideMenu = {
  UID?: string;
  sideMenus?: IDto[];
  sections?: SectionDto[];
  files?: FileRef[];
};

type Props = SideMenu;

const SideMenu: FC<Props> = ({ sideMenus, sections, files }) => {
  const cls = useStyles();
  // const { location: { pathname } } = useRouter();

  return (
    <>
      <ul className={cls.ul}>
        {sideMenus &&
          sideMenus.map((s, i) => {
            switch (s.type) {
              // case "NewsItemPage":
              //   const newsItemPage = s as NewsItemDto;
              //   return (
              //     <li key={newsItemPage.UID}>
              //       {i === 0 && (pathname === `/${Language}` || pathname === `/${Language}/news`) ?
              //         <div className={classNames(cls.navItem, 
              // cls.navItemActive)}>{newsItemPage.LeftSideTitle}</div> :
              //         <NavLink
              //           className={cls.navItem}
              //           to={`/${Language}/news/${newsItemPage.UID}`}
              //           activeClassName={cls.navItemActive}
              //         >
              //           {newsItemPage.LeftSideTitle}
              //         </NavLink>}
              //     </li>
              //   );
                
              // case "NewsItemLink":
              //   const newsItemLink = s as NewsItemLinkDto;
              //   return (
              //     <li key={newsItemLink.Anchor}>
              //       <a
              //         className={cls.navItem}
              //         href=""
              //         onClick={scrollToId(newsItemLink.Anchor)}
              //       >
              //         {newsItemLink.LeftSideTitle}
              //       </a>
              //     </li>
              //   );

              default:
                return null;
            }
          })
        }
        {sections && sections.map((s, i) =>
          <li key={s.UID}>
            <a
              className={classNames(cls.navItem, i === 0 && cls.navItemActive)}
              // tslint:disable-next-line:jsx-no-lambda
              onClick={i !== 0 ? scrollToId(s.UID) : scrollToId('')}
            >
              {s.Title}
            </a>
          </li>
        )}
      </ul>
      {files &&
        <ul className={cls.ul}>
          {files.map((f, i) =>
            <li key={`file-linl-${i}`}>
              <a
                href={`${f.Src}`}
                target="_blank"
                className={cls.navItem}
              >
                {f.Legend}
              </a>
            </li>
          )}
        </ul>
      }
    </>
  );
};

export default SideMenu;


// WEBPACK FOOTER //
// ./src/Components/SideMenu.tsx